import { Stack, Box, Divider, Paper, Typography } from "@mui/material"
import InvoiceStateComponent from "./components/InvoiceStateComponent"
import InvoiceInfoComponent from "./components/InvoiceInfoComponent"
import InvoiceAdressComponent from "./components/InvoiceAdressComponent"
import HeadingComponent from "./components/HeadingComponent"
import IntroductionComponent from "./components/IntroductionComponent"
import InvoiceItemsComponent from "./components/InvoiceItemsComponent"
import TextModelComponents from "./components/TextModelComponents"
import FooterComponent from "./components/FooterComponent"
import HeaderComponent from "./components/HeaderComponent"
import { usePermissions, useRecordContext } from "react-admin"
import { Permissions } from "../../authentication/Permissions"

interface IProps {
  resource: "invoices" | "drafts" | "reverseInvoices" | "invoiceReminders"
  isPreview: boolean
}

const InvoicePage = ({resource, isPreview}: IProps) => {

  const record = useRecordContext()
  const {isLoading, permissions} = usePermissions<Permissions>()
  
  if(!record || isLoading) return null

  return (
    <Paper elevation={5} sx={{width: "210mm", minHeight: "297mm", p: 10}} >
      <Stack spacing={1} minHeight={"297mm"} width={"100%"} justifyContent={"space-between"} direction={"column"}>
        <Box>
          {
            resource==="invoices" && !isPreview && <Box mb={2}><InvoiceStateComponent /></Box>
          }
          <HeaderComponent />
          <Divider sx={{my: 2}}/>
          <InvoiceInfoComponent />
          <InvoiceAdressComponent />
          <Box mt={6} mb={4} >
            <HeadingComponent />
          </Box>
          <IntroductionComponent />
          {
            resource !== "invoiceReminders" && 
            <>
              <InvoiceItemsComponent />
              <Box mt={6} mb={3} >
                <TextModelComponents />
              </Box>
            </>
          }
        </Box>
        <Box>
          {
            record.showFreeLogo &&
            <Box mb={1}>
              <Typography variant="body2" fontStyle={"italic"} color={"grey"}>{`Diese E-Rechnung wurde kostenlos mit ${permissions.redirectToFff ? "freeFiBU.de" : "freeBill.de"} erstellt`}</Typography>
            </Box>
          }
          <Divider sx={{mb: 2}} />
          <FooterComponent/>      
        </Box>
      </Stack>
    </Paper>

  )
}

export default InvoicePage